import { useMemo } from 'react';
import { Heading, SearchInput } from '@nbirl/nbi-common-ui-libs';

import { useQueryParams } from '../../../../shared/hooks';
import { useDashboards } from '../../context';
import { WorkbooksByCategoryPair } from '../../models';
import { DashboardsSearchCategory } from './dashboards-search-category.component';
import { DashboardsSearchEmpty } from './dashboards-search-empty.component';
import { DashboardsSearchLanding } from './dashboards-search-landing.component';

export const DashboardsSearch = () => {
  const [query, setQuery] = useQueryParams<{ search: string }>({
    search: '',
  });
  const { dashboardWorkbooksQuery } = useDashboards();

  const workbooksByCategory = useMemo(
    () => dashboardWorkbooksQuery.data?.workbooksByCategory || {},
    [dashboardWorkbooksQuery.data?.workbooksByCategory]
  );

  const filteredWorkbooksByCategory = useMemo<WorkbooksByCategoryPair[]>(
    () =>
      Object.entries(workbooksByCategory).reduce<WorkbooksByCategoryPair[]>(
        (matchingEntries, [category, workbooks]) => {
          const matchingWorkbooks = workbooks.filter((wb) => {
            const searchTerm = query.search.toLowerCase();
            return (
              wb.name.toLowerCase().includes(searchTerm) ||
              wb.description.toLowerCase().includes(searchTerm)
            );
          });
          return matchingWorkbooks.length > 0
            ? [...matchingEntries, [category, matchingWorkbooks]]
            : matchingEntries;
        },
        []
      ),
    [query.search, workbooksByCategory]
  );

  return (
    <div className="pb-6">
      <Heading className="py-6 mb-1">Search Workbooks</Heading>
      <div className="mb-8">
        <SearchInput
          value={query.search}
          onChange={(search) => setQuery({ search })}
        />
      </div>

      {!query.search && <DashboardsSearchLanding />}

      {query.search &&
        (filteredWorkbooksByCategory.length === 0 ? (
          <DashboardsSearchEmpty />
        ) : (
          <DashboardsSearchCategory
            workbooksByCategory={filteredWorkbooksByCategory}
          />
        ))}
    </div>
  );
};
